import AboveAverage from '@/assets/greatschools/rating-above-average.svg';
import Average from '@/assets/greatschools/rating-average.svg';
import BelowAverage from '@/assets/greatschools/rating-below-average.svg';
import NA from '@/assets/greatschools/rating-not-available.svg';

export function getRatingImage(rating: string | undefined | null) {
  switch (rating) {
    case 'Below average':
      return BelowAverage;
    case 'Above average':
      return AboveAverage;
    case 'Average':
      return Average;
    default:
      return NA;
  }
}
